var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.462,
    height: 18.915,
    viewBox: "0 0 20.462 18.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4524",
    "data-name": "Rectangle 4524",
    width: 20.462,
    height: 18.915,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11140",
    "data-name": "Group 11140",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44605",
    "data-name": "Path 44605",
    d: "M4.188,5.974a12.652,12.652,0,0,0,1.069,2.89,18,18,0,0,0,2.8,4.208c.163.179.327.443.525.479s.429-.169.639-.28c.391-.207.774-.426,1.164-.634a1.124,1.124,0,0,1,1.586.439q.794,1.356,1.571,2.723a1.124,1.124,0,0,1-.5,1.628c-1.018.495-2.042.978-3.067,1.459a.4.4,0,0,1-.26.016A6.978,6.978,0,0,1,7.25,17.525,18.534,18.534,0,0,1,3.535,13.3a23.362,23.362,0,0,1-3-6.257A10.9,10.9,0,0,1,0,3.737,10.24,10.24,0,0,1,.162,2.383a.421.421,0,0,1,.166-.249Q1.7,1.178,3.075.237a1.131,1.131,0,0,1,1.7.382Q5.56,1.958,6.328,3.3a1.134,1.134,0,0,1-.407,1.613c-.568.355-1.144.7-1.734,1.057",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44606",
    "data-name": "Path 44606",
    d: "M97.8,73.828c-.389-.513-.794-1.01-1.158-1.535a17.7,17.7,0,0,1-2.147-4.144.253.253,0,0,1,.135-.369c.426-.243.838-.512,1.269-.778L98.955,69.1l2.029,1.392a.548.548,0,0,0,.779,0l7.5-5.141c.064-.044.13-.086.226-.149a2.25,2.25,0,0,1,.028.241q0,4.7,0,9.4a.845.845,0,0,1-.891.889q-2.795.007-5.589,0a.318.318,0,0,1-.224-.14c-.3-.495-.579-1-.87-1.5a2.16,2.16,0,0,0-3.052-.85l-1.091.6",
    transform: "translate(-89.056 -61.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44607",
    "data-name": "Path 44607",
    d: "M133.769,59.209l-4.09-2.8c-.241-.165-.485-.327-.721-.5-.045-.033-.095-.12-.081-.163a2.228,2.228,0,0,0-.049-1.485h12.16l-7.219,4.95",
    transform: "translate(-121.454 -51.153)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIcon);
export default __webpack_public_path__ + "static/media/connect_icon.04718fe440aeff3ca0af916086c4d14e.svg";
export { ForwardRef as ReactComponent };